import { matchPath, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { pageTitles } from "../constants/constants";


export default function TitleUpdater({ children }) {
  const location = useLocation();

  useEffect(() => {
    const matched = pageTitles.find(p => matchPath({ path: p.path, end: true }, location.pathname));
    document.title = matched ? matched.title : "TalentHub";
  }, [location]);

  return children;
}
